import React, { useEffect, useState } from "react";
import { CanvasWidget } from "@projectstorm/react-canvas-core";
import { DiagramModel } from "@projectstorm/react-diagrams-core";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMaximize, faMinimize } from "@fortawesome/free-solid-svg-icons";
import Sidebar from "./components/Sidebar";
import ComponentNodeModel from "./nodes/ComponentNodeModel";
import ActivationModal from "./components/ActivationModal";
import { setCurrentModal } from "../store/slices/modalsSlice";
import ProjectProgress from "./components/ProjectProgress";
import SaveIcon from "../../assets/icons/save.svg2";

export default function ProjectBuilderMainWindow({ engine }) {
  const dispatch = useDispatch();
  const [dragged, setDragged] = React.useState(null);
  const [showFullScreen, setShowFullScreen] = useState(false);
  const [zoomLevel, setZoomLevel] = useState();

  const handleDrop = async (e, parentPort) => {
    if (dragged.id) {
      const model2 = new DiagramModel();
      model2.deserializeModel(dragged, engine);
      model2.registerListener({
        zoomUpdated: (event) => {
          setZoomLevel(event.zoom);
        },
      });
      setZoomLevel(model2.getZoomLevel());
      engine.setModel(model2);
      engine.repaintCanvas();
      return;
    }

    const node1 = new ComponentNodeModel({
      name: dragged.Label,
      color: "rgb(0,192,255)",
      componentID: dragged.ID,
      component: dragged,
    });

    const gridSize = 150;
    node1.setPosition(
      Math.round(
        (((e.clientX -
          e.target.getBoundingClientRect().left -
          engine.model.getOffsetX()) /
          engine.model.getZoomLevel()) *
          100) /
          gridSize
      ) * gridSize,
      Math.round(
        (((e.clientY -
          e.target.getBoundingClientRect().top -
          engine.model.getOffsetY()) /
          engine.model.getZoomLevel()) *
          100) /
          gridSize
      ) * gridSize
    );
    // 4) add the models to the root graph
    engine.model.addAll(node1);
    if (parentPort) {
      const l = parentPort.link(node1.getPort("In"));

      if (parentPort.options.alignment === "left") {
        node1.setPosition(
          parentPort.getParent().position.x - 450,
          parentPort.getParent().position.y + 300
        );
      }
      if (parentPort.options.alignment === "right") {
        node1.setPosition(
          parentPort.getParent().position.x + 450,
          parentPort.getParent().position.y + 300
        );
      }
      if (parentPort.options.alignment === "bottom") {
        node1.setPosition(
          parentPort.getParent().position.x,
          parentPort.getParent().position.y + 450
        );
      }

      engine.model.addAll(l);

      const targetID = dragged.ID;
      const sourceID = parentPort.parent.options.component.ID;
      dispatch(
        setCurrentModal({
          modal: "activation",
          data: { targetID, sourceID },
        })
      );
    }
    engine.repaintCanvas();
  };

  engine.handleDrop = handleDrop;

  useEffect(() => {
    setZoomLevel(engine.model.getZoomLevel());
    engine.model.registerListener({
      zoomUpdated: (event) => {
        setZoomLevel(event.zoom);
      },
    });
  }, []);

  return (
    <>
      <div
        style={
          showFullScreen
            ? {
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1021,
                background: "var(--page-background)",
              }
            : { height: "800px", position: "relative", marginBottom: 50 }
        }
        className="d-flex pt-3"
      >
        <Sidebar
          setDragged={setDragged}
          setShowFullScreen={() => setShowFullScreen(!showFullScreen)}
        />
        <div
          className="h-100 rounded-3 p-3 flex-grow-1 position-relative"
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => handleDrop(e)}
          onDoubleClick={() => engine.zoomToFit()}
        >
          <div className="position-absolute top-0 end-0 start-0 z-1 d-flex justify-content-between align-items-center mx-5">
            <button
              type="button"
              className="btn btn-white rounded-pill fw-bold px-3"
              onClick={() => {
                const serializedModel = engine.model.serialize();
                const templates =
                  JSON.parse(localStorage.getItem("projectTemplates")) || [];
                localStorage.setItem(
                  "projectTemplates",
                  JSON.stringify([
                    ...templates.filter((t) => t.id !== serializedModel.id),
                    serializedModel,
                  ])
                );
              }}
            >
              <SaveIcon width="1rem" className="me-2" />
              SAVE
            </button>
            <input
              type="range"
              className="ms-auto"
              min={1}
              max={200}
              value={zoomLevel}
              title={engine.model.getZoomLevel()}
              onChange={(e) => {
                engine.model.setZoomLevel(e.target.value);
                engine.repaintCanvas();
              }}
            />
            <button
              type="button"
              onClick={() => setShowFullScreen(!showFullScreen)}
              className="btn"
            >
              <FontAwesomeIcon
                icon={showFullScreen ? faMinimize : faMaximize}
              />
            </button>
          </div>
          <CanvasWidget className="h-100" engine={engine} />
        </div>
        <ProjectProgress />
      </div>
      <ActivationModal />
    </>
  );
}
